export interface PermissionObj {
    resource: string;
    operations: Operation[];
}

export enum Operation {
    Create = 0,
    Read = 1,
    Update = 2,
    Delete = 3,
    Deny = 4
}
